export default {
  TOKEN: `web_token`,
};
